import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { ArrowIcon } from 'app/commonComponents/icons';
import { DropdownMenu } from 'app/components/menus';
import { colors } from 'app/variables';

import form from 'modules/ticketPublicPage/stores/tickets/form';
import view from 'modules/ticketPublicPage/stores/tickets/view';
import {
  NumInput,
  FakeInputStyle,
  FakeSelectArrow,
  FakeSelectText,
  FakeSelectContainer,
} from './styles';

@observer
class TicketNumInput extends Component {
  state = {
    open: false,
  };
  anchorElRef = React.createRef();
  _handleClick = () => {
    this.setState({ open: !this.state.open });
  };
  _onSelect = (num) => {
    const { setFormValue } = form;
    setFormValue('num', num);
    this.setState({ open: false });
  };
  render() {
    const { formValues } = form;
    const {
      minNumber,
      maxNumber,
      activeObject: { type },
    } = view;
    const { open } = this.state;
    const values = Array.from(
      { length: maxNumber - minNumber + 1 },
      (_, index) => minNumber + index
    );
    const items = values.map((val) => {
      if (type === 'event') {
        return i18n.sprintf(i18n.ngettext('%s Ticket', '%s Tickets', val), val);
      }
      return i18n.sprintf(i18n.ngettext('%s Coupon', '%s Coupons', val), val);
    });
    const selectedIndex = values.indexOf(formValues.get('num'));
    const selectedItem = selectedIndex > -1 ? items[selectedIndex] : values[0];

    return (
      <NumInput>
        <React.Fragment>
          <DropdownMenu
            anchorEl={this.anchorElRef.current}
            open={open}
            closeMenu={() => this.setState({ open: !this.state.open })}
            onSelect={this._onSelect}
            items={items}
            values={values}
            selectedItems={[selectedItem]}
          />
          <FakeInputStyle
            aria-label={i18n.sprintf(i18n.gettext('%s selected'), selectedItem)}
            ref={this.anchorElRef}
            onClick={this._handleClick}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation();
                this._handleClick();
              }
            }}
          >
            <FakeSelectContainer>
              <FakeSelectText>{selectedItem}</FakeSelectText>
              <FakeSelectArrow>
                <ArrowIcon small style={{ color: colors.pacificBlue }} />
              </FakeSelectArrow>
            </FakeSelectContainer>
          </FakeInputStyle>
        </React.Fragment>
      </NumInput>
    );
  }
}

export default TicketNumInput;
